export default () => ({
  loading: false,
  orders: [],
  refreshActiveOrders: false,
  activeOrders: [],
  completedOrders: [],
})
